<template>
  <div class="modal-address">
    <b-modal
      v-model="showModal"
      size="xl"
      centered
      :title="typeModal === 'add' ? 'Ingresa la nueva dirección' : 'Editar dirección'"
      :hide-footer="true"
    >
      <form @submit.prevent="submitAddress()">
        <div class="row">
          <div class="col-6 left">
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label for="ma-department" class="mb-1">Departamento</label>
                  <select
                    v-model="form.departmentU"
                    id="ma-department"
                    class="form-control form-control-sm"
                    required
                  >
                    <option value="">Seleccionar</option>
                    <option v-for="i in deliveryZones.ubigeo" :key="i.id" :value="i.id">
                      {{ i.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="ma-province" class="mb-1">Provincia</label>
                  <select
                    v-model="form.province"
                    id="ma-province"
                    class="form-control form-control-sm"
                    required
                  >
                    <option value="">Seleccionar</option>
                    <option v-for="i in listProvinces" :key="i.id" :value="i.id">
                      {{ i.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="ma-distrit" class="mb-1">Distrito</label>
                  <select
                    v-model="form.ubigeoId"
                    id="ma-distrit"
                    class="form-control form-control-sm"
                    required
                  >
                    <option value="">Seleccionar</option>
                    <option v-for="i in listDistricts" :key="i.id" :value="i.id">
                      {{ i.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="ma-zone" class="mb-1">Zona de reparto</label>
                  <select
                    v-model="form.zoneId"
                    id="ma-zone"
                    class="form-control form-control-sm"
                    required
                  >
                    <option value="">Seleccionar</option>
                    <option v-for="i in listZones" :key="i.id" :value="i.id">
                      {{ i.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="ma-address" class="mb-1">Dirección</label>
                  <input
                    v-model="form.address"
                    id="ma-address"
                    type="text"
                    class="form-control form-control-sm"
                    required
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="ma-lot" class="mb-1">Nro/Lote</label>
                  <input
                    v-model="form.lot"
                    id="ma-lot"
                    type="text"
                    class="form-control form-control-sm"
                    required
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="ma-dpto" class="mb-1">Dpto./int (Opcional)</label>
                  <input
                    v-model="form.department"
                    id="ma-dpto"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="ma-ubr" class="mb-1">Urbanización (Opcional)</label>
                  <input
                    v-model="form.urbanization"
                    id="ma-ubr"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label for="ma-ref" class="mb-1">Referencia (Opcional)</label>
                  <input
                    v-model="form.reference"
                    id="ma-ref"
                    type="text"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 right">
            <Map
              :typeModal="typeModal"
              :coordinates="coordinates"
              @assignCoordinates="setCoordinates"
            />
          </div>
        </div>

        <hr />
        <h6>¿Quién recibirá el producto?</h6>
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="name" class="mb-1">Nombres</label>
              <input
                v-model="form.firstName"
                id="name"
                type="text"
                class="form-control form-control-sm"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="lastname" class="mb-1">Apellidos</label>
              <input
                v-model="form.lastName"
                id="lastname"
                type="text"
                class="form-control form-control-sm"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="form-group">
              <label for="phone" class="mb-1">Teléfono celular</label>
              <input
                v-model="form.phone"
                id="phone"
                type="text"
                class="form-control form-control-sm"
                @keypress="isNumber"
                required
              />
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-5">
                <div class="form-group">
                  <label for="documentType" class="mb-1">Tipo documento</label>
                  <select
                    v-model="form.documentType"
                    id="documentType"
                    class="form-control form-control-sm"
                    required
                  >
                    <option value="">Seleccionar</option>
                    <option value="DNI">DNI</option>
                    <option value="RUC">RUC</option>
                  </select>
                </div>
              </div>
              <div class="col-7">
                <div class="form-group">
                  <label for="document" class="mb-1">Nº documento</label>
                  <input
                    v-model="form.document"
                    id="document"
                    class="form-control form-control-sm"
                    type="text"
                    required
                    :minlength="form.documentType === 'DNI' ? 8 : 6"
                    :maxlength="form.documentType === 'DNI' ? 8 : 15"
                    @keypress="isNumber"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div class="modal-buttons">
          <button type="submit" class="btn btn-primary rounded-50">Guardar dirección</button>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    typeModal: {
      type: String,
      default: ''
    },
    deliveryZones: {
      type: [],
      default: () => []
    }
  },
  data() {
    return {
      form: {
        address: '',
        department: '',
        departmentU: '',
        lot: '',
        province: '',
        reference: '',
        ubigeoId: '',
        urbanization: '',
        zoneId: '',
        zoneMethodId: '',
        name: 'Casa',
        session: '',
        firstName: '',
        lastName: '',
        phone: '',
        documentType: '',
        document: '',
        latitude: '',
        longitude: '',
        location: ''
      },

      listProvinces: [],
      listDistricts: [],
      listZones: []
    };
  },
  watch: {
    'form.departmentU'(curr) {
      this.form.departmentU = curr;
      this.changeDepartment();
    },
    'form.province'(curr) {
      this.form.province = curr;
      this.changeProvince();
    },
    'form.ubigeoId'(curr) {
      this.form.ubigeoId = curr;
      this.changeDistrict();
    },
    typeModal() {
      this.setValues();
    }
  },
  computed: {
    showModal: {
      get() {
        return this.$store.state.delivery.showModalNewAddress;
      },
      set() {
        this.$store.commit('setShowModalNewAddress');
      }
    },
    auth() {
      return this.$store.state.auth;
    },
    coordinates() {
      return {
        lat: Number(this.form.latitude),
        lng: Number(this.form.longitude),
        location: this.form.location
      };
    }
  },
  methods: {
    submitAddress() {
      if (this.typeModal === 'add') {
        this.addAddress(this.form);
      } else {
        this.updateAddress(this.form);
      }
    },
    async addAddress(form) {
      try {
        await this.$store.dispatch('addUserAddress', form);
      } catch (error) {
        console.log(error);
      }
    },
    async updateAddress(form) {
      form.status = 1;
      try {
        await this.$store.dispatch('updateUserAddress', form);
      } catch (error) {
        console.log(error);
      }
    },
    changeDepartment() {
      const dObj = this.deliveryZones.ubigeo.find((i) => i.id === this.form.departmentU);
      if (dObj) {
        this.listProvinces = dObj.children;
      }
    },
    changeProvince() {
      const dObj = this.listProvinces.find((i) => i.id === this.form.province);
      if (dObj) {
        this.listDistricts = dObj.children;
      }
    },
    changeDistrict() {
      const dObj = this.listDistricts.find((i) => i.id === this.form.ubigeoId);
      if (dObj) {
        const listZones = [];
        this.deliveryZones.data.forEach((item) => {
          const locationAux = item.locations.find(
            (item2) => item2.ubigeoId === parseInt(dObj.id, 10)
          );

          if (locationAux) {
            listZones.push({
              id: item.id,
              name: item.name,
              methods: item.methods
            });
          }
        });
        this.listZones = listZones;
      }
    },
    isNumber(val) {
      if (isNaN(Number(val.key))) {
        return val.preventDefault();
      }
    },
    setValues() {
      if (this.typeModal === 'edit') {
        const cloneAddress = { ...this.$store.getters.getAddress };
        this.form = cloneAddress;
        this.form.departmentU = cloneAddress.ubigeo[2].id;
        this.form.province = cloneAddress.ubigeo[1].id;
      } else {
        this.form = {
          address: '',
          department: '',
          departmentU: '',
          lot: '',
          province: '',
          reference: '',
          ubigeoId: '',
          urbanization: '',
          zoneId: '',
          zoneMethodId: '',
          name: 'Casa',
          session: '',
          firstName: '',
          lastName: '',
          phone: '',
          documentType: '',
          document: '',
          latitude: '',
          longitude: '',
          location: ''
        };
      }
    },
    setCoordinates(value) {
      if (value) {
        this.form.latitude = value.lat.toString();
        this.form.longitude = value.lng.toString();
        this.form.location = value.location;
      }
    }
  }
};
</script>
<style lang="scss">
.modal-buttons {
  text-align: center;
}
</style>
